import { store } from 'index';

export const make_hash = (array: { [key: string]: any }[]) => {

    const state = store.getState();
    let   hash  = state.content.hash;

    for (let i = 0; i < array.length; i++) {

      const id = !!array[i].puzzle_id ? array[i].puzzle_id : !!array[i].uid ? `${ array[i].uid }` : array[i].lesson_id;

        if (id) {
            hash[id]          = array[i];
            hash[id].liked    = 0;
            hash[id].selected = 0;
            hash[id].viewed   = 0;
        }

      
    }

    return hash
          
}

/* 

export const make_hash = (array: { [key: string]: any }[]) => {

    let hash: { [key: string]: any } = {};
    
        for (let i = 0; i < array.length; i++) {
    
          const id = !!array[i].puzzle_id ? array[i].puzzle_id : !!array[i].uid ? `${ array[i].uid }` : array[i].lesson_id;
    
            if (id) {
                hash[id]          = array[i];
                hash[id].liked    = 0;
                hash[id].selected = 0;
                hash[id].viewed   = 0;
            }
    
          
        }
    
        return hash
              
    }
    

   
   
   
   
   
   
   
    */